/**
 * 用户处理退款
 * */
import React, { useCallback, useState } from 'react';
import { Modal, Form, Divider, Select, Button, Input, message } from 'antd';
import { debounce } from 'lodash-es';
import dayjs from 'dayjs';
import HTTP from '../../../script/service';
import Util from '../../../script/util';
import './OrderHandle.scss';

const OrderPlayHandle = ({ visible, orderInfo, close, reload }) => {
  const [form] = Form.useForm();
  const { resetFields } = form;
  const [refundPrice, setRefundPrice] = useState(0); // 退款钻石数

  const hideModal = () => {
    // 关闭弹窗重置填写的内容
    resetFields();
    setRefundPrice(0);
    close();
  };

  const onSubmit = (values) => {
    HTTP._modified_order({
      uid: orderInfo.playUid,
      orderId: orderInfo.orderId,
      orderStatus: 6,
      ...values,
    }).then((res) => {
      if (res?.code === 200) {
        hideModal();
        reload();
      } else {
        message.warning(res?.message || '操作失败，请稍后重试哦~');
      }
    });
  };

  // 服务时长
  const onChangeActualDuration = useCallback(
    debounce((e) => {
      const { value } = e.target;
      calcRefundPrice(value);
    }, 600),
    [orderInfo]
  );

  const calcRefundPrice = (duration) => {
    if (!duration || duration < 0 || duration > orderInfo.viewUnitNum) return;

    HTTP._get_calculate_refund_diamond({
      actualServiceDuration: duration,
      orderId: orderInfo.orderId,
    })
      .then((res) => {
        if (res?.code === 200) {
          setRefundPrice(res.data);
        } else {
          message.warning(res?.message || '获取失败，请稍后重试~');
        }
      })
      .catch((err) => {
        setRefundPrice(0);
        message.warning('获取失败，请稍后重试~');
      });
  };

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
  };
  return (
    <Modal
      open={visible}
      title="确定申请退款"
      wrapClassName="daidai-modal-style has-top-border order-refund-modal"
      centered
      footer={null}
      keyboard={false}
      maskClosable={false}
      onCancel={hideModal}
      width={600}
      zIndex={1010}
    >
      {!!orderInfo && (
        <Form
          form={form}
          className="appeal-form"
          onFinish={onSubmit}
          {...layout}
        >
          <Form.Item label="订单信息" className="order-info-form">
            <div className="form-value order-info">
              <div className="cover">
                <img
                  src={Util.transImgUrl(
                    orderInfo?.categoryIcon || null,
                    '28x28'
                  )}
                  alt={orderInfo?.categoryName || ''}
                />
              </div>
              <p className="name">{orderInfo?.categoryName}</p>
              <p className="price red-txt">
                {orderInfo.totalDiamond - orderInfo.discountDiamond}钻
              </p>
            </div>
          </Form.Item>
          <Form.Item label="订单号">
            <div className="form-value">{orderInfo.orderId}</div>
          </Form.Item>
          <Form.Item label="订单时长">
            <div className="form-value">
              {orderInfo.viewUnitNum}
              {orderInfo.viewUnit}
            </div>
          </Form.Item>
          <Form.Item label="开始服务时间">
            <div className="form-value">
              {dayjs(orderInfo.orderBeginTime).format('YYYY-MM-DD HH:mm:ss')}
            </div>
          </Form.Item>
          {!!(orderInfo.discountDiamond && orderInfo.discountAmount) && (
            <Form.Item label="优惠券">
              <div className="form-value coupon-info">
                <i className="icon-coupon" />
                <span className="price red-txt">
                  {orderInfo.discountAmount}元
                </span>
                <span className="diamond red-txt">
                  抵扣{orderInfo.discountDiamond}钻
                </span>
              </div>
            </Form.Item>
          )}
          <Divider type="horizontal" />
          <p className="tip-txt-1" style={{ marginBottom: 12 }}>
            请填写以下信息，提交后将由系统进行最终裁决：
          </p>
          <Form.Item
            label="退款原因"
            className="form-fill-in"
            name="cancelReason"
            rules={[{ required: true, message: '请选择退款原因' }]}
          >
            <Select
              className="select-reason"
              classNames={{ popup: { root: 'daidai-select-dropdown' } }}
              placeholder="请选择退款原因"
              style={{ width: 280 }}
            >
              <Select.Option value="1">不想打了</Select.Option>
              <Select.Option value="2">协商一致退款</Select.Option>
              <Select.Option value="3">大神没有时间</Select.Option>
              <Select.Option value="4">大神水平差</Select.Option>
              <Select.Option value="5">大神服务态度恶劣</Select.Option>
              <Select.Option value="6">大神未履行服务</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="实际服务时长" className="form-fill-in actual-duration">
            <Form.Item
              name="actualServiceDuration"
              rules={[
                { required: true, message: '请输入服务时长' },
                {
                  pattern: /^[+]?\d+(\.\d+)?$/,
                  message: '请输入正确的服务时长',
                },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve(); // 避免空值也进来
                    const num = parseFloat(value);
                    if (num > orderInfo.viewUnitNum) {
                      return Promise.reject('实际服务时长不能大于总时长');
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                placeholder="不超过订单总时长"
                style={{ width: 240 }}
                autoComplete="off"
                onChange={onChangeActualDuration}
              />
            </Form.Item>
            <span className="extra-txt">{orderInfo.viewUnit}</span>
          </Form.Item>
          <p className="tip-txt-1">
            系统根据填写的服务时长计算出“申请退款金额”
          </p>
          <p className="tip-txt-2" style={{ marginBottom: 12 }}>
            (退款金额=实付金额*未服务时长/总服务时长)
          </p>
          <Form.Item label="退款金额" className="refund-form">
            <div className="form-value refund">
              <span className="num red-txt">{refundPrice}</span>
              <span className="unit red-txt">钻</span>
            </div>
          </Form.Item>
          <ol className="tip-txt-3">
            <p>说明：</p>
            <li>订单总金额是包含使用优惠劵的金额。</li>
            <li>
              若使用优惠劵下单，实付金额=订单总金额-优惠劵抵扣金额。请注意，使用优惠劵下单，若订单产生部分退款，优惠劵视为“已使用”，
              不支持再次使用。
            </li>
            <li>
              买二赠一订单将按照三单计算。例如：下单2小时，最后计算会按照3小时计算。
            </li>
            <li>
              发起退款将会后台审核。若订单最终退款，实际退款金额以最终裁决为准。
            </li>
            <li>实际服务时长支持填写小数点后1位。</li>
          </ol>

          <Form.Item className="form-footer">
            <Button className="daidai-btn" onClick={hideModal}>
              我再想想
            </Button>
            <Button className="daidai-btn-primary" htmlType="submit">
              确定退款
            </Button>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default OrderPlayHandle;
